import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from '../../../common/header/header.component';

import { FooterComponent } from '../../../common/footer/footer.component';
import { LocaleService } from '../../../../locale/locale.service';
import { ClaimsService } from '../../../../services/claims.service';
import { MultiplePartyInvolvementType } from '../../../../enums/externals-involved-type';
import { FormNavigationService } from '../../../../services/form-navigation/form-navigation.service';
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-multiple-party-involvement-check',
  imports: [FormsModule, HeaderComponent, FooterComponent, ReactiveFormsModule],
  templateUrl: './multiple-party-involvement-check.component.html',
  styleUrl: './multiple-party-involvement-check.component.css',
})
export class MultiplePartyInvolvementCheckComponent implements OnInit {
  locale = inject(LocaleService);
  private claimService = inject(ClaimsService);
  private formNavigationService = inject(FormNavigationService);

  public showError = false;
  radioControl = new FormControl();
  options: { headline: string; caption: string; value: string }[] = [];

  constructor() {
    this.options = [
      {
        headline:
          this.locale.currentTranslation
            .multiplePartyInvolvementOptionHeadline1,
        caption:
          this.locale.currentTranslation.multiplePartyInvolvementOptionCaption1,
        value: MultiplePartyInvolvementType.OnlyMe,
      },
      {
        headline:
          this.locale.currentTranslation
            .multiplePartyInvolvementOptionHeadline2,
        caption:
          this.locale.currentTranslation.multiplePartyInvolvementOptionCaption2,
        value: MultiplePartyInvolvementType.AnotherExternal,
      },
      {
        headline:
          this.locale.currentTranslation
            .multiplePartyInvolvementOptionHeadline3,
        caption:
          this.locale.currentTranslation.multiplePartyInvolvementOptionCaption3,
        value: MultiplePartyInvolvementType.Both,
      },
    ];
  }

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.externalsInvolved) {
        this.radioControl.patchValue(
          this.claimService.claimReport().externalsInvolved
        );
      }
    });
  }

  nextClicked() {
    this.evaluateShowError();
    if (!this.showError) {
      const rawValue = this.radioControl.getRawValue();
      this.claimService.updateClaimReport({ externalsInvolved: rawValue });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['multiple-party-involvement'], [
          rawValue,
        ]);
      });
    }
  }

  private evaluateShowError() {
    this.showError = this.radioControl.getRawValue() === null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false;
  }
}
